import React, { useState } from 'react'
import Header from '../components/Header'
import {  useNavigate } from 'react-router-dom'
const Login = () => {
  const [name, setName] = useState("")
  const [password, setPassword] = useState("")
  const navigate=useNavigate()
  const handlesubmit=(e)=>{
     e.preventDefault()
if(name==="admin" && password==="123456789"){
navigate("/admin")
 }else{
    alert("Parol yoki login notugri qaytadan urinib kuring")
  }
  }
  
 
  return (
    <div>
      <div className="body2">
        <Header />
        <div className="signup-container">
          <form id="signup-form" className="signup-form" onSubmit={handlesubmit}>
            <h2>Kurslar uchun ruyhatdan uting</h2>

            <div className="input-group">
              <label htmlFor="username">Ism</label>
              <input type="text" id="username" name="username" placeholder="Enter your username" value={name }onChange={(e)=>setName(e.target.value)} />
              <small id="username-error" className="error-message"></small>
            </div>



            <div className="input-group">
              <label htmlFor="password">password</label>
              <input type="password" id="password" name="password" placeholder="123456789" value={password} onChange={(e)=>setPassword(e.target.value)} />
              <small id="password-error" className="error-message"></small>
            </div>


            <button type="submit" className="submit-btn">Ruyhatdan o`tish</button>
            

          </form>
        </div></div>
    </div>
  )
}

export default Login